import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Forward: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75 20.1153C7.79308 16.6538 8.79 15.2691 12.75 15.2691H14.8269V19.423L21.75 11.8076L14.8269 4.88452V9.03837H13.4423C6.51923 9.03837 5.13462 15.9614 3.75 20.1153Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
